import { SIZES, Typography } from '@fupa/fupa-uikit';
import MatchResult from 'app/components/matchRow/MatchResult';
import React from 'react';
import MatchRowTeaserKickoff from 'app/components/matchRow/teaser/MatchRowTeaserKickoff';
import styled from 'styled-components';
import MatchResultTeaserResultHint from 'app/components/matchRow/teaser/MatchResultTeaserResultHint';
const Wrapper = styled.div.withConfig({
  componentId: "sc-1x3zge6-0"
})(["position:relative;width:", ";height:", ";display:flex;justify-content:center;align-items:center;"], SIZES['46'], SIZES['30']);
export default function MatchRowTeaserResult(_ref) {
  let {
    matchResult,
    color
  } = _ref;
  if (matchResult.isCancelled()) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Typography, {
      variant: 'caption1'
    }, "abgesagt"));
  } else if (!matchResult.hasVerdict() && (matchResult.isInFuture() || matchResult.isRunningWithoutTicker())) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(MatchRowTeaserKickoff, {
      kickoff: matchResult.formatKickoff(),
      live: matchResult.hasLiveticker()
    }));
  }
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "MatchRowTeaserResult",
    "data-sentry-source-file": "MatchRowTeaserResult.tsx"
  }, /*#__PURE__*/React.createElement(MatchResult, {
    matchResult: matchResult,
    allowLive: true,
    color: color,
    "data-sentry-element": "MatchResult",
    "data-sentry-source-file": "MatchRowTeaserResult.tsx"
  }), /*#__PURE__*/React.createElement(MatchResultTeaserResultHint, {
    flags: matchResult.result.flags,
    "data-sentry-element": "MatchResultTeaserResultHint",
    "data-sentry-source-file": "MatchRowTeaserResult.tsx"
  }));
}